import MapDataStream from '../MapDataStream'
import { Observable } from 'rxjs';

export default class RasterTileDataStream extends MapDataStream {
    constructor(id, tilesUrl, tileSize, minZoom, maxZoom) {
        super(id);

        this.tilesUrl = tilesUrl;
        this.tileSize = tileSize;
        this.minZoom = minZoom;
        this.maxZoom = maxZoom;
    }

    observe() {
        const observable = new Observable((subscriber) => {
            this.subscriber = subscriber;
        });
        return observable;
    }

    observeSelection() {
        const observable = new Observable((subscriber) => {
            this.selectionSubscriber = subscriber;
        });
        return observable;
    }
}